import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
  'content-calendar.field-1-name': {
    id: 'content-calendar.field-1-name',
    defaultMessage: 'Name',
    description:
      'The field name (and the default value/watermark) in field #1 for this database template. In this case: Name'
  },
  'content-calendar.field-2-name': {
    id: 'content-calendar.field-2-name',
    defaultMessage: 'Status',
    description:
      'The field name (and the default value/watermark) in field #2 for this database template. In this case: Status'
  },
  'content-calendar.field-2-select-option-1': {
    id: 'content-calendar.field-2-select-option-1',
    defaultMessage: 'Complete',
    description:
      'The option value for option #1 in field #2 for this database template. In this case: Complete'
  },
  'content-calendar.field-2-select-option-2': {
    id: 'content-calendar.field-2-select-option-2',
    defaultMessage: 'On hold',
    description:
      'The option value for option #2 in field #2 for this database template. In this case: On hold'
  },
  'content-calendar.field-2-select-option-3': {
    id: 'content-calendar.field-2-select-option-3',
    defaultMessage: 'Planning',
    description:
      'The option value for option #3 in field #2 for this database template. In this case: Planning'
  },
  'content-calendar.field-3-name': {
    id: 'content-calendar.field-3-name',
    defaultMessage: 'Month',
    description:
      'The field name (and the default value/watermark) in field #3 for this database template. In this case: Month'
  },
  'content-calendar.field-3-select-option-1': {
    id: 'content-calendar.field-3-select-option-1',
    defaultMessage: 'January',
    description:
      'The option value for option #1 in field #3 for this database template. In this case: January'
  },
  'content-calendar.field-3-select-option-2': {
    id: 'content-calendar.field-3-select-option-2',
    defaultMessage: 'February',
    description:
      'The option value for option #2 in field #3 for this database template. In this case: February'
  },
  'content-calendar.field-3-select-option-3': {
    id: 'content-calendar.field-3-select-option-3',
    defaultMessage: 'March',
    description:
      'The option value for option #3 in field #3 for this database template. In this case: March'
  },
  'content-calendar.field-3-select-option-4': {
    id: 'content-calendar.field-3-select-option-4',
    defaultMessage: 'April',
    description:
      'The option value for option #4 in field #3 for this database template. In this case: April'
  },
  'content-calendar.field-4-name': {
    id: 'content-calendar.field-4-name',
    defaultMessage: 'Owner',
    description:
      'The field name (and the default value/watermark) in field #4 for this database template. In this case: Owner'
  },
  'content-calendar.field-5-name': {
    id: 'content-calendar.field-5-name',
    defaultMessage: 'Documentation',
    description:
      'The field name (and the default value/watermark) in field #5 for this database template. In this case: Documentation'
  },
  'content-calendar.view-1-name': {
    id: 'content-calendar.view-1-name',
    defaultMessage: 'All content',
    description:
      'The view name for view #1 in this template. Displayed on the top left of the screen (below the database name). In this case: All content'
  },
  'content-calendar.entry-1-cell-1': {
    id: 'content-calendar.entry-1-cell-1',
    defaultMessage: 'Product launch',
    description:
      'The text value of cell #1 in row (entry) #1 in this database template. In this case:  Product launch'
  },
  'content-calendar.entry-2-cell-1': {
    id: 'content-calendar.entry-2-cell-1',
    defaultMessage: 'Social media campaign',
    description:
      'The text value of cell #1 in row (entry) #2 in this database template. In this case:  Social media campaign'
  },
  'content-calendar.entry-3-cell-1': {
    id: 'content-calendar.entry-3-cell-1',
    defaultMessage: 'Industry event',
    description:
      'The text value of cell #1 in row (entry) #3 in this database template. In this case:  Industry event'
  },
  'content-calendar.entry-4-cell-1': {
    id: 'content-calendar.entry-4-cell-1',
    defaultMessage: 'Webinar',
    description:
      'The text value of cell #1 in row (entry) #4 in this database template. In this case:  Webinar'
  }
});
